/**
 *  Copyright (c) 2021-present The TVM Engineering Authors.
 *
 */

const STATIC_ROUTES = {
  landingPage: "/",
  signup: "/signup",
  logout: "/logout",
  // confirmRegistration: "/?token",
  confirmRegistration: "/confirm-registration/:token",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password/:resetToken",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
  imprint: "/imprint",
  shareDownloadLink: "/share-download/:data",
  dashboardHome: "/dashboard",
  companies: "/dashboard/companies",
  companyById: "/dashboard/companies/:companyId",
  users: "/dashboard/users",
  terms: "/dashboard/terms",
  fileManagement: "/dashboard/file-management",
  fileId: "/dashboard/file-management/:id",
  downloadHistory: "/dashboard/download-history",
  projects: "/dashboard/projects",
  projectId: "/dashboard/projects/:id",
  roleManagement: "/dashboard/role-management",
  accountSettings: "/dashboard/account-settings",
  testPage: "/dashboard/test-page",
  userProfile: "/dashboard/users/:id",
  news: "/dashboard/news",
  newsById: "/dashboard/news/:id",
  fileCatalog: "/dashboard/file-catalog",
  fileRequests: "/dashboard/file-requests",
  myFiles: "/dashboard/my-files",


  admin: "/admin",
  dashboard: "/dashboard",
  // projects: "/projects",
  projectsTable: "/projects-table",
  uploads: "/uploads",
  profile: "/profile",
  termsAndConditions: "/terms",
  // downloadHistory: "/download-history",
  maintenance: "/maintenance",
  registrationForward: "/registration",
};

export default STATIC_ROUTES;

// ***** ROUTES that are not used *****
// removeUser: "/remove-user",
// RegistrationForward: "/registration",
// contacts: "/contacts",
// cookie: "/cookie",
// support: "/support",
// contactUs: "/contact-us",
// errorPage: "/error-page",
// contactUsTechSupport: "/contact-us/tech-support",
